import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ArrowUp = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M11.3972036,4.16783276 L6.1914578,8.94174236 C5.95461474,9.16435275 5.9271039,9.52565118 6.16753434,9.78556072 C6.38164972,10.0174952 6.80030805,10.0233253 7.03355608,9.80887083 L11.2058082,5.97661489 L11.2058082,19.4032613 C11.2058082,19.7331086 11.4797315,20 11.8182489,20 C12.1567663,20 12.4306896,19.7330997 12.4306896,19.4032613 L12.4306896,5.97661489 L16.6029417,9.80887083 C16.8361959,10.0233238 17.2441059,10.0081726 17.4689635,9.78556072 C17.7058065,9.5501294 17.6854705,9.16083498 17.44504,8.94174236 L12.2392942,4.16783276 C12.098145,4.02797213 11.961782,4.00233026 11.8182413,4 C11.6771074,4 11.4881204,4.08391638 11.3972036,4.16783276 Z"
        />
    </StarryUIIcon>
);
